import InlineToast from '@/components/toasts/inline';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';
import { Box } from '@mui/material';
import { FC } from 'react';

interface Props {
  policy: PolicyModel;
}

const MonitorWarningToast: FC<Props> = ({ policy }) => {
  const isMonitored = policy.publicServices?.action === 'monitored';

  if (!isMonitored) {
    return null;
  }

  return (
    <Box mb={4}>
      <InlineToast
        level="warning"
        message={`WARNING: The Default Service Action setting "Allow - Monitor" will override all action settings on this page, other than "Ignore".`}
      />
    </Box>
  );
};

export default MonitorWarningToast;
